import Env from '../../base/env'
import Channels from '../../base/channels'
import axios from 'axios'
import matchSorter from 'match-sorter'

export default class Dispatch
{
    constructor(view)
    {
        this.view = view
        this.$dispatch = this.view.querySelector('.jsDispatch--view')
        this.$collection = this.view.querySelector('.jsCollection')
        this.$triggers = Env.$master.querySelectorAll('.jsDispatch--trigger')
        this.$keyboard = this.view.querySelector('.jsDispatch--shortcut .text')
        this.$filters = this.$dispatch.querySelectorAll('.jsFilter')
        this.$receptorGrid = this.view.querySelector('.jsDispatch--receptorGrid')
        this.$receptorGridCells = this.$receptorGrid.querySelectorAll('.cell')
        this.$receptorGridMobile = this.view.querySelector('.jsDispatch--receptorGridMobile')
        this.$receptorList = this.view.querySelector('.jsDispatch--receptorList')
        this.$form = this.view.querySelector('.jsField--trigger')
        this.$field = this.view.querySelector('.jsField--search')
        this.$matches = this.view.querySelector('.jsDispatch--matches')
        this.$anchors = this.view.querySelector('.jsAnchors')
        this.$anchorsTrigger = this.view.querySelectorAll('.jsAnchor')
        // Arrays
        this.listTags = []
        // Flags
        this.IS_ANIMATED = false
        this.STATUS = false
        // Fns
        this.funcClose = this.close.bind(this)
        this.fnkeyUp = this.detectKeypress.bind(this)
        this.setup()
        this.events()
    }

    applyMatch(match = '')
    {
        if(match != null) {
            this.$matches.innerHTML = ''
            this.$field.value = match.value
            this.send(match.id)
        }
    }

    cleanActive()
    {
        for ( const $filter of this.$filters ) {
            $filter.classList.remove('is--active')
        }
    }

    destroy()
    {
        Channels.removeListener('dispatch::close', this.funcClose);
        Env.$window.removeEventListener('keyup',this.fnkeyUp)
    }

    events()
    {
        var
        self = this

        for ( const e of this.$triggers ) {
            e.addEventListener('click',()=>{
                this.toggle()
                return false;
            },false)
        }

        for ( const $filter of this.$filters ) {
            $filter.addEventListener('click',()=>{
                this.cleanActive()
                this.send($filter.getAttribute('data-id'))
                $filter.classList.add('is--active')
                return false;
            },false)
        }

        for ( const $anchor of this.$anchorsTrigger ) {
            const id = $anchor.getAttribute('data-id')
            const anchorSlug = `.anchor--${id}`;
            $anchor.addEventListener('click',()=>{
                const $targets = this.$dispatch.querySelectorAll(anchorSlug)
                this.setAnchor($targets[0].offsetTop,$anchor,$targets)
                // console.log($targets[0].offsetTop);
                return false;
            },false)

        }

        Env.$window.addEventListener('keyup',this.fnkeyUp)

        this.$form.addEventListener('submit',(event)=>{
            if(this.$field.value !== "") {
                this.filter(true)
            }
            event.preventDefault()
        })
        this.$form.addEventListener('keyup',(event)=>{
            this.filter()
            event.preventDefault()
        })

        Channels.on('dispatch::close',this.funcClose)
    }

    close()
    {
        if(this.STATUS === true) {
            this.toggle(true)
        }
    }

    detectKeypress(e)
    {
        // ESC
        if(e.keyCode == 27) {
            if(this.STATUS === true) {
                this.toggle(true)
            }

        // F
        } else if(e.keyCode == 70) {
            if(this.STATUS === false) {
                this.toggle(false)
            }
        }
    }

    filter(force = false)
    {
        const value = this.$field.value
        const matches = matchSorter(this.listTags, value , {keys: ['value', 'id']})
        this.$matches.innerHTML = ''

        if(force == true) {
            if(matches.length > 0) {
                const match = matches[0]
                this.applyMatch(match)
            }
        } else {
            if(value.length > 0) {
                for(let i = 0; i < matches.length; i++) {
                    let li = document.createElement('li')
                    const content = matches[i]
                    li.innerHTML = content.value
                    this.$matches.appendChild(li)
                    li.addEventListener('click',()=>{
                        this.applyMatch(content)
                    })
                }
            }
        }
    }

    onWatch()
    {
        const scroll = Env.framework.toolbox.scrollPosition()
        this.$dispatch.style.top = `${scroll.scrollY}px`
    }


    reset()
    {
        this.$form.reset()
        this.$matches.innerHTML = ''
        this.$field.focus()
    }

    send(id)
    {
        axios.get(config.pathRoot+'/works-filtering/'+id).then((response)=> {
            if(response.data.items.length > 0) {
                Channels.emit('works::clean')
                const datasItems = response.data.items
                const cellGrid1 = this.$receptorGridCells[0]
                const cellGrid2 = this.$receptorGridCells[1]
                for(let i = 0; i < datasItems.length; i++) {
                    const item = datasItems[i]
                    const column = i%2
                    // Item Grid
                    const categoriesRendered = item.categories_ordered.join(', ')
                    let blockGrid = document.createElement('a')
                    blockGrid.setAttribute('href',item.url_rendered)
                    blockGrid.classList.add('workspace-grid__item')
                    const htmlItemGrid = `
                    <div class="visual">
                        <img src="${item.visual_grid['url']}" alt="" class="out">
                        <img src="${item.visual_grid['url']}" alt="" class="in">
                    </div>
                    <h3 class="h4 text__color--loud">${item.title.rendered}</h3>
                    <p class="h5 text__color--light">${ categoriesRendered }</p>
                    `;
                    blockGrid.innerHTML = htmlItemGrid
                    const cloneBlockGrid = blockGrid.cloneNode(true)
                    cloneBlockGrid.classList.add('jsItem')
                    // Append
                    if(column === 0) {
                        cellGrid1.appendChild(cloneBlockGrid)
                    } else if(column === 1) {
                        cellGrid2.appendChild(cloneBlockGrid)
                    }
                    this.$receptorGridMobile.appendChild(blockGrid)
                }

                const datasListItems = response.data.list_items
                for(let j = 0; j < datasListItems.length; j++) {
                    const item = datasListItems[j]
                    const categoriesRendered = item.categories_ordered.join(', ')
                    // List
                    let blockList = document.createElement('div')
                    blockList.setAttribute('data-img',item.visual_grid['url'])
                    blockList.setAttribute('data-slug',item.slug)
                    blockList.classList.add('workspace-list__item')
                    blockList.classList.add('jsItem')
                    const htmlItemList = `
                    <a href="${item.url_rendered}" class="link-context">
                        <span class="title">${item.title.rendered}</span>
                        <span class="category">${ categoriesRendered }</span>
                        <span class="date">${ item.release_date.segments[1] }</span>
                    </a>
                    `;
                    blockList.innerHTML = htmlItemList
                    this.$receptorList.appendChild(blockList)
                }

                Channels.emit('works::render')
                Channels.emit('dispatch::close')
            }
        });
    }

    setAnchor(y,$anchorActive,$filters)
    {
        TweenLite.to(this.$collection,.5, { ease : Cubic.easeOut , y : y * -1 })
        for ( const $anchor of this.$anchorsTrigger ) {
            $anchor.classList.remove('is--active')
        }
        $anchorActive.classList.add('is--active')
        for(let i = 0; i < this.$filters.length; i++) {
            this.$filters[i].classList.add('is--disabled')
        }
        for(let j = 0; j < $filters.length; j++) {
            $filters[j].classList.remove('is--disabled')
        }
    }

    setup()
    {
        for(let i = 0; i < this.$filters.length; i++) {
            const filter = this.$filters[i]
            let value = filter.querySelector('.text').innerHTML
            value = value.replace(/&amp;/g, '&');
            this.listTags.push({ value : value , id : filter.getAttribute('data-id') })
        }
    }

    toggle(_status)
    {
        let timeline = new TimelineLite()
        if (typeof _status === 'undefined')
            _status = this.$dispatch.classList.contains('is--active')

        if(this.IS_ANIMATED == false)
        {
            if(!!_status)
            {
                this.STATUS = false
                this.$keyboard.innerHTML = wording.ctaFilter
                timeline.add([
                    TweenLite.to(this.$form , .3 , { opacity : 0 } , { opacity : 0 , ease : Cubic.easeIn   }),
                    TweenLite.to(this.$anchors , .3 , { opacity : 0 } , { opacity : 0 , ease : Cubic.easeIn }),
                    TweenMax.staggerTo(this.$filters , .4 , { opacity : 0 , ease : Cubic.easeIn,
                        onStart : ()=>{
                            this.IS_ANIMATED = true
                        }
                    },.02,()=>{
                        this.IS_ANIMATED = false
                        this.$dispatch.classList.remove('is--active');
                        Env.$html.classList.remove('dispatch--isOpened')
                        this.$collection.removeAttribute('style')
                        for(let i = 0; i < this.$filters.length; i++) {
                            this.$filters[i].classList.remove('is--disabled')
                        }
                        for(let j = 0; j < this.$anchorsTrigger.length; j++) {
                            this.$anchorsTrigger[j].classList.remove('is--active')
                        }
                    })
                ])

            }
            else
            {
                this.STATUS = true
                this.$keyboard.innerHTML = wording.ctaFilterClose
                this.reset()
                this.$dispatch.classList.add('is--active');
                Env.$html.classList.add('dispatch--isOpened')
                timeline.add([
                    TweenLite.fromTo(this.$form , .8 , { opacity : 0 } , { opacity : 1 , ease : Cubic.easeOut ,  delay : .5  }),
                    TweenLite.fromTo(this.$anchors , .8 , { opacity : 0 } , { opacity : 1 , ease : Cubic.easeOut ,  delay : .5 }),
                    TweenMax.staggerFromTo(this.$filters , .8 , { opacity : 0 , x : -15 } , { opacity : 1 , x : 0 , ease : Power4.easeOut , delay : .3 ,
                        onStart : ()=>{
                            this.IS_ANIMATED = true
                        }
                    },.05,()=>{
                        this.IS_ANIMATED = false
                    })
                ])
            }
        }
    };
}